'use client'

import { FC } from 'react'

import ModalBase from '@/components/commons/ModalBase'

import { buildCustomMessageAttentionCase } from './buildCustomMessageAttentionCase'
import { CustomMessageAttentionModalProps } from './types'

const CustomMessageAttentionModal: FC<CustomMessageAttentionModalProps> = ({
  isOpenModal,
  setIsOpenModal,
  customMessage,
  messageKeyPrefix = 'custom-message',
  className,
  ...props
}) => {
  function handleCloseModal() {
    setIsOpenModal(false)
  }

  const content = buildCustomMessageAttentionCase({
    customMessage,
    keyPrefix: messageKeyPrefix,
    onClose: handleCloseModal,
  })

  return (
    <ModalBase
      className={`w-full max-w-[464px] ${className ?? ''}`}
      isOpenModal={isOpenModal}
      {...props}
    >
      <ModalBase.Header>
        {content.icon}
        {content.title}
        {content.paragraph}
      </ModalBase.Header>
      <ModalBase.Footer className="justify-end">
        {content.buttons}
      </ModalBase.Footer>
    </ModalBase>
  )
}

export default CustomMessageAttentionModal
